import React from 'react';
import Navbar from './Navbar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-vh-100">
      <Navbar />
      <main className="container-fluid mt-4">
        {children}
      </main>
    </div>
  );
};

export default Layout;
